<template>
  <div class="container">
    <div class="row d-flex align-items-center" v-if="show_team_row">
      <div class="col">
        <LogoLarge :path="bidding_team.icon"></LogoLarge>
      </div>
      <div class="col-5 fw-bold">
        {{ bidding_team.name }}
      </div>
      <div class="col text-success">
        {{ team_players.length }}/{{ auction.team_size }}
      </div>
      <div class="col-3"><UnsoldPlayers></UnsoldPlayers></div>
      <div class="col text-warning">{{ formatToIndianCurrency(max_bid) }}</div>
      <div class="col fw-bold">
        {{ formatToIndianCurrency(bidding_team.wallet) }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
import LogoLarge from "../logos/LogoLarge.vue";
import { onMounted, ref, computed } from "vue";
import UnsoldPlayers from "./UnsoldPlayers.vue";
const store = useStore();
const show_team_row = ref(false);
const bidding_team = ref({});
const team_players = ref([]);
const auction = ref({});
onMounted(() => {
  fetchTeam();
  setTimeout(() => {
    setBiddingTeamID();
    fetchPlayers();
    fetchAuction();
    show_team_row.value = true;
  }, 1000);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
};
const fetchPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("team_id", bidding_team.value.id);
  team_players.value = players;
  setupPlayersListner();
};
const setupPlayersListner = () => {
  const channels = supabase
    .channel("bidding-team-players-custom-all-channel")
    .on(
      "postgres_changes",
      { event: "*", schema: "public", table: "players" },
      (payload) => {
        if (
          payload.eventType == "UPDATE" &&
          payload.new.auction_id == store.live_auction
        ) {
          if (payload.new.team_id == bidding_team.value.id) {
            team_players.value.push(payload.new);
          }
          if (!payload.new.team_id) {
            const index = team_players.value.findIndex(
              (obj) => obj.id === payload.new.id
            );
            if (index) {
              team_players.value = team_players.value.splice(index, 1);
            }
          }
        }
      }
    )
    .subscribe();
};
const setBiddingTeamID = () => {
  store.setBiddingTeam(bidding_team.value.id);
};
const fetchTeam = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("bid_email", store.user.email)
    .eq("auction_id", store.live_auction);
  bidding_team.value = teams[0];
  setTimeout(() => {
    setupListner();
  }, 500);
};
const setupListner = () => {
  const channels = supabase
    .channel("bidding-team-listner-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "teams",
        filter: `id=eq.${bidding_team.value.id}`,
      },
      (payload) => {
        bidding_team.value = payload.new;
      }
    )
    .subscribe();
};
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
const max_bid = computed(() => {
  var max = 0;
  store.setMaxBid(0);
  if (team_players.value.length) {
    max =
      bidding_team.value.wallet -
      auction.value.bid_increment *
        (auction.value.team_size - team_players.value.length - 1);
  } else {
    max =
      bidding_team.value.wallet -
      auction.value.bid_increment * (auction.value.team_size - 1);
  }
  store.setMaxBid(max);
  return max;
});
</script>
